module.exports = __webpack_public_path__ + "static/image/history/pc/202112.ver2_0_2.jpg?88b4de81";